import { rgba } from 'polished';

const colors = {
  transparent: 'transparent', // 0
  black: '#000000', // 1
  white: '#ffffff', // 2
  headingColor: '#1A1A1A', // 3 - app brand near-black
  textColor: rgba('#1A1A1A', 0.65), // 4
  textColorAlt: '#5C5C5C', // 5 - app muted text
  textColorLight: rgba('#fff', 0.7), // 6
  labelColor: '#5C5C5C', // 7
  background: '#F0F0F3',
  surface: '#FFFFFF',
  surfaceMuted: '#F7F7F9',
  surfaceRaised: '#FAFAFB',
  inactiveField: '#F7F7F9', // 8
  inactiveButton: '#E6E6EA', // 9
  inactiveIcon: '#ECECEF', // 10
  primary: '#1A1A1A', // 11 - app brand color
  primaryHover: '#000000', // 12
  secondary: '#F7D786', // 13 - app gold accent
  secondaryDark: '#A67C1A', // 13b - readable gold for text on white
  outline: '#C8C8CC',
  borderColor: '#D4D4D8', //14 - app card outline
  borderColorMuted: '#DCDCE0',
  linkColor: '#1A1A1A', // 15
  label: '#1A1A1A', // 16,
  rating: '#F7D786', // 17 - gold stars
  danger: '#B00020', // 18 - app error red
  dark: '#1A1A1A', // 19
  cream: '#FDF5E6', // 20 - app tertiary cream
  success: '#2E7D32',
  focusRing: 'rgba(247, 215, 134, 0.55)',
  darkOverlay: 'rgba(26, 26, 26, 0.88)',
  primaryBoxShadow: '0px 8px 20px -6px rgba(26, 26, 26, 0.25)',
  secondaryBoxShadow: '0px 8px 20px -6px rgba(247, 215, 134, 0.55)',
  cardShadow: '0 10px 30px rgba(26, 26, 26, 0.07)',
  pricingShadow: '0px 28px 54px rgba(26, 26, 26, 0.10)',
};

export default colors;
